import { getObservableById, setObservableById } from './helper';

export const biEventsParams$ = new Map();
export const getBiEventsParams$ = (compId: string) =>
  getObservableById(biEventsParams$, compId, {});
export const setBiEventsParams$ = (biEventsParams: object, compId: string) =>
  setObservableById(biEventsParams$, biEventsParams, compId);
